import React, { useState, useEffect } from "react";
import ApiService from "../services/ApiService";
import { Loader2 } from "lucide-react";

interface StatusResponse {
  orders: number;
  averageProcessingTime: number;
}

const StatusSection: React.FC = () => {
  const [status, setStatus] = useState<StatusResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        setLoading(true);
        setError(false);

        const response = await ApiService.get("/services/status");
        const data = await response.json();

        setStatus(data);
      } catch (err) {
        console.error("Failed to fetch status:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchStatus();
  }, []);

  // If there's an error, don't show anything to avoid affecting the UI
  if (error) {
    return null;
  }

  return (
    <div className="bg-emerald-600 text-white py-2 px-4 text-xs sm:text-sm shadow-md border-b border-emerald-700">
      <div className="max-w-6xl mx-auto flex flex-wrap justify-center items-center gap-2 sm:gap-3">
        {loading ? (
          <div className="flex items-center justify-center">
            <Loader2 className="h-3 w-3 sm:h-4 sm:w-4 animate-spin mr-1 sm:mr-2" />
            <span className="font-medium">Loading...</span>
          </div>
        ) : (
          <>
            <div className="flex items-center whitespace-nowrap">
              <span className="font-semibold mr-1">Today:</span>
              <span className="font-medium">
                {status?.orders || 0}{" "}
                <span className="hidden sm:inline">checks completed</span>
                <span className="sm:hidden">checks</span>
              </span>
            </div>
            <div className="text-xs sm:text-sm mx-1 font-bold">•</div>
            <div className="flex items-center whitespace-nowrap">
              <span className="font-semibold mr-1">
                <span className="hidden sm:inline">
                  Average processing time:
                </span>
                <span className="sm:hidden">Avg:</span>
              </span>
              <span className="font-medium">
                {status?.averageProcessingTime || 0}{" "}
                <span className="hidden sm:inline">minutes</span>
                <span className="sm:hidden">mins</span>
              </span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default StatusSection;
